export const LEGAL_NOTICE_TITLES = {
  fr: 'Mentions légales (Impressum)',
  de: 'Impressum',
  en: 'Legal notice (Impressum)',
  es: 'Aviso legal',
  it: 'Note legali (Impressum)',
  zh: '法律声明 (Impressum)'
};

export const LEGAL_NOTICE_LINKS = {
  fr: 'Mentions légales',
  de: 'Impressum',
  en: 'Legal notice',
  es: 'Aviso legal',
  it: 'Note legali',
  zh: '法律声明'
};
